import { IAction } from "../../../interface/action.interface";
import { IFooterDto } from "../interface/dto/footer.dto";

export enum GlobalsActionType {
    GLOBALS_INIT = "GLOBALS_INIT",
    GLOBALS_GET = "GLOBALS_GET",
    GLOBALS_GET_SUCCESS = "GLOBALS_GET_SUCCESS",
    GLOBALS_GET_ERROR = "GLOBALS_GET_ERROR",
}

export interface IGlobalsInitAction extends IAction {
    type: GlobalsActionType.GLOBALS_INIT;
}

export interface IGlobalsGetAction extends IAction {
    type: GlobalsActionType.GLOBALS_GET;
}

export interface IGlobalsSuccessAction extends IAction {
    type: GlobalsActionType.GLOBALS_GET_SUCCESS;
    payload: IFooterDto;
}

export interface IGlobalsErrorAction extends IAction {
    type: GlobalsActionType.GLOBALS_GET_ERROR;
    payload: {
        error: string;
    };
}

export const globalsInitAction = (): IGlobalsInitAction => ({
    type: GlobalsActionType.GLOBALS_INIT,
    payload: {},
});

export const globalsGetAction = (): IGlobalsGetAction => ({
    type: GlobalsActionType.GLOBALS_GET,
    payload: {},
});

export const globalsSuccessAction = (
    footer: IFooterDto,
): IGlobalsSuccessAction => ({
    type: GlobalsActionType.GLOBALS_GET_SUCCESS,
    payload: footer,
});

export const globalsErrorAction = (error: string) => ({
    type: GlobalsActionType.GLOBALS_GET_ERROR,
    payload: { error },
});

export type IGlobalAction =
    | IGlobalsInitAction
    | IGlobalsGetAction
    | IGlobalsSuccessAction
    | IGlobalsErrorAction;
